import { ActivityEntityName } from '@jms/model';
import type { EntityDialogs } from '@workbuddy/ui/v2/blocks/entity.dialog';
import type { JobItemBoardParams } from '../../../models/job.item.model';
import type { ItemDetailPageData } from '../../components/item.detail.page';
import type { JobItemDetailParams } from '../../../surface/detail/job.item.detail.context';
import { resolveItemRecord } from '../../row/item.row.record';

/** Opens the SOR Details page, the Job Item `expand` operation on every host. */
export function openJobItemSurfaceDetail(dialogs: Pick<EntityDialogs, 'open'>, row: unknown, params: JobItemBoardParams): Promise<boolean> {

  const item = resolveItemRecord(row);
  if (!item?._id) return Promise.resolve(false);

  const stageId = (row as { workOrders?: { _id?: string } })?.workOrders?._id ?? params.stageId() ?? undefined;

  return dialogs.open({
    entity: ActivityEntityName.JobItem,
    operation: 'expand',
    id: item._id,
    params: {
      itemId: item._id,
      itemName: item.name,
      jobId: params.job()?._id,
      stageId,
      timezone: params.timezone(stageId),
      itemsChanged: params.itemsChanged,
      stageOpenForContractor: params.stageOpenForContractor?.(),
    } satisfies ItemDetailPageData & JobItemDetailParams,
    source: { entity: ActivityEntityName.JobItem, id: item._id },
    afterSave: () => params.itemsChanged(),
  });
}

/** SOR-only expand handler. Omit when dialogs are missing so the icon stays hidden. */
export function jobItemSorExpandInteraction(dialogs: Pick<EntityDialogs, 'open'> | null | undefined, params: JobItemBoardParams | undefined): { onExpand: (row: unknown) => Promise<void> } | undefined {

  if (!dialogs || !params) return undefined;

  return {
    onExpand: async row => {
      await openJobItemSurfaceDetail(dialogs, row, params);
    },
  };
}
